import { Component, OnInit } from '@angular/core';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute } from '@angular/router';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-failed-packages-detail',
    templateUrl: './failed-packages-detail.component.html',
    styleUrls: ['./failed-packages-detail.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class FailedPackagesDetailComponent implements OnInit {

  public title = 'Failed package';
  public pageActions: PageAction[];

  public packageId: string;

  public failedPackage: Models.Package;
  public cache;

  constructor(public packageService: PackageService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.packageId = this.route.snapshot.params['id'];
    if (this.packageId) {
      this.packageService.get(this.packageId).then(result => {
        if (result) {
          this.failedPackage = result;
          this.title += ' ' + result.title;
        }
      })
    }
  }

}
